import TicketMappingModal from "../../../components/TicketMappingModal";

const SeatingMapModal = ({ showSeatingMapOverview, showModal, closeModal }) => {
  if (showSeatingMapOverview) {
    return <TicketMappingModal showModal={showModal} onClose={closeModal} />;
  }
  return null;
};
export default SeatingMapModal;



// WEBPACK FOOTER //
// ./routes/tickets/components/SeatingMapModal.js